import { ActionContext } from 'vuex';
import { Settings, Store, SettingsStore, ILegalResponse } from '@/models';
import { getSettings, getLegalSettings, getEulaPpHtml } from '@/services/settingsService';

const state: SettingsStore = {
  isMaintenanceModeOff: true,
  maintenanceModeMessage: '',
  eulaVersion: '',
  ppVersion: '',
  isOpenedFromPp: false
};

const getters = {
  isMaintenanceModeOff (moduleState: Settings) {
    return moduleState.isMaintenanceModeOff;
  },
  maintenanceModeMessage (moduleState: Settings) {
    return moduleState.maintenanceModeMessage;
  },
  ppVersion (moduleState: SettingsStore) {
    return moduleState.ppVersion;
  },
  eulaVersion (moduleState: SettingsStore) {
    return moduleState.eulaVersion;
  },
  isOpenedFromPp (moduleState: SettingsStore) {
    return moduleState.isOpenedFromPp;
  }
};

const mutations = {
  setIsMaintenanceModeOff (moduleState: Settings, isMaintenanceModeOff: boolean): void {
    moduleState.isMaintenanceModeOff = isMaintenanceModeOff;
  },
  setMaintenanceModeMessage (moduleState: Settings, maintenanceModeMessage: string): void {
    moduleState.maintenanceModeMessage = maintenanceModeMessage;
  },
  setPpVersion (moduleState: SettingsStore, ppVersion: string): void {
    moduleState.ppVersion = ppVersion;
  },
  setEulaVersion (moduleState: SettingsStore, eulaVersion: string): void {
    moduleState.eulaVersion = eulaVersion;
  },
  setIsOpenedFromPP (moduleState: SettingsStore, isOpenedFromPp: boolean): void {
    moduleState.isOpenedFromPp = isOpenedFromPp;
  }
};

const actions = {
  async updateSettings (action: ActionContext<SettingsStore, Store>) {
    const settings = await getSettings();
    action.commit('setIsMaintenanceModeOff', settings.isMaintenanceModeOff);
    action.commit('setMaintenanceModeMessage', settings.maintenanceModeMessage);
  },
  async updateLegalSettings (action: ActionContext<SettingsStore, Store>, brand: string) {
    try {
      const legalSettings = await getLegalSettings(brand) as ILegalResponse;
      if (legalSettings.liveEulaPrivacyPolicy && Object.keys(legalSettings.liveEulaPrivacyPolicy).length > 0) {
        if (legalSettings.liveEulaPrivacyPolicy.privacyPolicy.version) action.commit('setPpVersion', legalSettings.liveEulaPrivacyPolicy.privacyPolicy.version);
        if (legalSettings.liveEulaPrivacyPolicy.eula.version) action.commit('setEulaVersion', legalSettings.liveEulaPrivacyPolicy.eula.version);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error fetching legal settings:', error);
      return false;
    }
  },
  async updateIsOpenedFromPP (action: ActionContext<SettingsStore, Store>, isOpenedFromPp: boolean) {
    action.commit('setIsOpenedFromPP', isOpenedFromPp);
  },
  async getEulaPpHtml (_: ActionContext<SettingsStore, Store>, params: { htmlContentType: string, platform?: string, brand: string, version: string }) {
    try {
      const { htmlContentType, platform, brand, version } = params;
      const htmlContent = await getEulaPpHtml(
        htmlContentType,
        platform || '',
        brand,
        version
      );
      return htmlContent;
    } catch (error) {
      console.error('Error fetching EULA/PP HTML content:', error);
      return {
        htmlBody: '<div>Error retrieving the content</div>'
      };
    }
  }
};

export const settings = {
  state,
  mutations,
  getters,
  actions
};
